<template>
  <div class="register-page">
      <div class="register-header">
          <img class="logo" src="../../assets/images/logo_navbar.png" alt="衣加加云平台" title="衣加加云平台">
      </div>
      <div class="register-main">
        <div class="register-main-title">注册</div>
        <div class="register-main-box">
            <el-form :model="regForm" :rules="rules" ref="regForm" label-position="top"
              :hide-required-asterisk="true"
            >
                <el-form-item label="您的身份" prop="">
                    <div class="identity-select">
                        <div class="identity-box" :class="{act: identityType == 1}" @click="identityType = 1">
                            <i class="avatar avatar_1"></i>
                            <strong>品牌商</strong>
                        </div>
                        <div class="identity-box" :class="{act: identityType == 2}" @click="identityType = 2">
                            <i class="avatar avatar_2"></i>
                            <strong>生产商</strong>
                        </div>
                        <div class="identity-box" :class="{act: identityType == 9}" @click="identityType = 9">
                            <i class="avatar avatar_3"></i>
                            <strong>直播相关</strong>
                        </div>
                    </div>
                </el-form-item>
          
                <template v-if="identityType == 1">
                  <el-form-item label="您的主要销售渠道（可多选）" prop="validChannel">
                    <el-checkbox 
                      :label="item.dataName" 
                      v-for="(item,index) in channel.list" :key="item.dataName + index"
                      @change="(e) => selectChannel(e, item) "
                    ></el-checkbox>
                  </el-form-item>

                  <el-form-item label="您的主营品类（可多选）" prop="validClothesData">
                      <div class="cate-line" 
                        v-for="(item, index) in clothesData" :key="item.dataName + index">
                          <strong class="cate-lab">{{item.dataName}}</strong>
                          <div class="cate-select">
                            <el-tag 
                              v-for="(ele, i) in item.list" :key="ele+i"
                              closable
                              size="medium"
                              @close="closeClothesTag(ele)"
                              v-show="ele.checked"
                            >{{ele.name}}</el-tag>
                            <el-button size="mini" icon="el-icon-plus" @click="selectCatePop = true">品类</el-button>
                          </div>
                      </div>
                  </el-form-item>
                </template>

                <template v-if="identityType == 2">
                  <el-form-item label="您擅长加工的品类（可多选）" prop="validClothesData2">
                      <div class="cate-line" 
                        v-for="(item, index) in clothesData2" :key="item.dataName + index">
                          <strong class="cate-lab">{{item.dataName}}</strong>
                          <div class="cate-select">
                            <el-tag 
                              v-for="(ele, i) in item.list" :key="ele+i"
                              closable
                              size="medium"
                              @close="closeClothesTag(ele)"
                              v-show="ele.checked"
                            >{{ele.name}}</el-tag>
                            <el-button size="mini" icon="el-icon-plus" @click="selectCatePop = true">品类</el-button>
                          </div>
                      </div>
                  </el-form-item>
                  <el-form-item label="您是否具备采购面辅料的能力" prop="canBuyFabricAbility">
                    <el-radio-group v-model="regForm.canBuyFabricAbility">
                      <el-radio label="具备"></el-radio>
                      <el-radio label="不具备"></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="您所能处理的加工环节(可多选)" prop="validProcessing">
                    <el-checkbox :label="item.dataName"
                      v-for="(item, index) in processing.list" :key="item.dataName + index"
                      @change="(e) => selectProcessing(e, item) "
                    ></el-checkbox>
                    <br>
                    <el-checkbox label="其他" v-model="processingOther"></el-checkbox>
                    <el-input size="small" class="write-other"
                      type="text" v-model="processingOtherText"
                      placeholder="请输入加工环节" v-show="processingOther"
                    />
                  </el-form-item>
                  <el-form-item label="您所能处理的特殊工艺(可多选)" prop="validSpecialProcess">
                    <el-checkbox :label="item.dataName"
                      v-for="(item, index) in specialProcess.list" :key="item.dataName + index"
                      @change="(e) => selectSpecialProcess(e, item)"
                    ></el-checkbox>
                    <br>
                    <el-checkbox label="其他" v-model="specialProcessOther"></el-checkbox>
                    <el-input size="small" class="write-other"
                      type="text" v-model="specialProcessOtherText"
                      placeholder="请输入特殊工艺" v-show="specialProcessOther"
                    />
                  </el-form-item>
                  <el-form-item label="您主要的品质产出" prop="validQuality">
                    <el-radio-group v-model="qualitySelect">
                      <el-radio :label="item.dataName"
                        v-for="(item, index) in quality.list" :key="item.dataName + index"
                        @change="(e) => selectQuality(e, item)"
                      ></el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="员工人数" prop="staffsNumber">
                    <el-input size="small" style="width: 450px" v-model.trim="regForm.staffsNumber"
                      type="number"
                      placeholder="请输入员工人数"
                    ></el-input>
                  </el-form-item>
                </template>

                <template  v-if="identityType == 9">
                  <el-form-item label="公司或机构名称" prop="company">
                    <el-input size="small" style="width: 450px" v-model.trim="regForm.company"
                      type="text"
                      placeholder="请输入公司或机构名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="直播客单价范围" prop="priceDuring">
                    <el-input size="small" style="width: 130px" v-model.trim="regForm.priceStart"
                      type="text"
                      placeholder="请输入价格"
                    ></el-input>
                    <span style="margin: 0 15px; color: #DCDFE6">——</span>
                    <el-input size="small" style="width: 130px" v-model.trim="regForm.priceEnd"
                      type="text"
                      placeholder="请输入价格"
                    ></el-input>
                    <span style="margin: 0 10px;">元</span>
                  </el-form-item>
                  <el-form-item label="主要直播类目(可多选）" prop="cateForLive">
                    <el-checkbox-group v-model="regForm.cateForLive">
                      <el-checkbox label="女装" name="cateForLive"></el-checkbox>
                      <el-checkbox label="男装" name="cateForLive"></el-checkbox>
                      <el-checkbox label="女童" name="cateForLive"></el-checkbox>
                      <el-checkbox label="男童" name="cateForLive"></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>

                   
                </template>


                <div class="divider"></div>
                <el-form-item label="设置密码" prop="password1">
                    <el-input size="small" style="width: 450px" v-model.trim="regForm.password1"
                      type="password"
                      placeholder="请输入6~16位组合密码"
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="password2">
                    <el-input size="small" style="width: 450px" v-model.trim="regForm.password2"
                      type="password"
                      placeholder="请再次输入密码"
                    ></el-input>
                </el-form-item>
                <br><br>
                <el-form-item>
                  <el-button type="primary" @click="submitForm">确认注册</el-button>
                </el-form-item>
            </el-form>
            <el-dialog title="选择主营品类" :visible.sync="selectCatePop" width="900px" class="dialog-header-border">
                <div class="cate-pop" v-if="identityType == 1">
                    <div class="cate-line" v-for="(item, index) in clothesData" :key="item.dataName + index">
                      <strong class="cate-lab">{{item.dataName}}</strong>
                      <div class="cate-select w">
                          <el-checkbox :label="ele.name"
                            v-for="(ele, i) in item.list" :key="ele+i"
                            v-model="ele.checked"
                            @change="changeClothesTag"
                          ></el-checkbox>
                      </div>
                  </div>
                </div>
                <div class="cate-pop" v-if="identityType == 2">
                    <div class="cate-line" v-for="(item, index) in clothesData2" :key="item.dataName + index">
                      <strong class="cate-lab">{{item.dataName}}</strong>
                      <div class="cate-select w">
                          <el-checkbox :label="ele.name"
                            v-for="(ele, i) in item.list" :key="ele+i"
                            v-model="ele.checked"
                            @change="changeClothesTag"
                          ></el-checkbox>
                      </div>
                  </div>
                </div>
                
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="selectCatePop = false">确 定</el-button>
                </div>
            </el-dialog>
        </div>
      </div>
      <y-footer />
  </div>
</template>

<script>
import yFooter from '../../components/yFooter.vue'
import request from '@/utils/request.js'
import api from '@/api/index.js'
import { validateCombinationPwd, validatePrice } from '@/utils/validate.js'
import { mapGetters } from 'vuex'
export default {
    name: 'register',
    components: {
        yFooter
    },
    data() {
      var validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else if (!validateCombinationPwd(value)) {
          callback(new Error('请输入6-16位组合密码'))
        } else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        // console.log(value,value,value)
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.regForm.password1) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback();
        }
      };
      var validateChannel = (rule, value, callback) => {
        if (this.channel.list.some(item => item.isSelect == '1')) {
          callback()
        } else {
          callback(new Error('请选择您的主要销售渠道'))
        }
      };
      var validateClothesData = (rule, value, callback) => {
        if (this.clothesData.some(item => item.checked)) {
          callback()
        } else {
          callback(new Error('请选择您的主营品类'))
        }
      };
      var validateClothesData2 = (rule, value, callback) => {
        if (this.clothesData2.some(item => item.checked)) {
          callback()
        } else {
          callback(new Error('请选择您的主营品类'))
        }
      };
      var validateProcessing = (rule, value, callback) => {
        if (this.processing.list.some(item => item.isSelect == '1') || this.processingOther) {
          callback()
        } else {
          callback(new Error('请选择您所能处理的加工环节'))
        }
      };
      var validateSpecialProcess = (rule, value, callback) => {
        if (this.specialProcess.list.some(item => item.isSelect == '1') || this.specialProcessOther) {
          callback()
        } else {
          callback(new Error('请选择您所能处理的特殊工艺'))
        }
      };

      var validateQuality = (rule, value, callback) => {
        if (this.quality.list.some(item => item.isSelect == '1')) {
          callback()
        } else {
          callback(new Error('请选择您主要的品质产出'))
        }
      };

      var validatePriceDuring = (rule, value, callback) => {
        if (this.regForm.priceStart === '' || this.regForm.priceEnd === '') {
          callback(new Error('请输入单价范围'))
        } else if (!validatePrice(this.regForm.priceStart) || !validatePrice(this.regForm.priceEnd)) {
          callback(new Error('价格格式不正确'))
        } else {
          callback()
        }
      }
      
      
      return {
        identityType: 1,  // 0 - 未选择  1 - 品牌商  2 - 生产商  9 - 直播相关
        selectCatePop: false,

        // 品牌商
        channel: {},  // 销售渠道
        clothesData: [],  // 品类

        // 生产商
        clothesData2: [], // 品类

        // 您所能处理的加工环节(可多选)
        processing: {},  
        processingOther: false,  // 其它选项 是否勾选
        processingOtherText: '', // 其它选项 填写内容

        // 您所能处理的特殊工艺(可多选)
        specialProcess: {},
        specialProcessOther: false,
        specialProcessOtherText: '',

        // 品质产出
        quality: {},
        qualitySelect: '',


        regForm: {
         password1: '',
         password2: '',

         canBuyFabricAbility: '', // 您是否具备采购面辅料的能力
         staffsNumber: '', // 员工人数

         company: '', // 公司或机构名称
         priceStart: '', 
         priceEnd: '',
         cateForLive: []
        },
        rules: {
          password1: [
            { validator: validatePass1, trigger: 'blur' }
          ],
          password2: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          validChannel: [
            { validator: validateChannel }
          ],
          validClothesData: [
            { validator: validateClothesData }
          ],
          validClothesData2: [
            { validator: validateClothesData2 }
          ],
          canBuyFabricAbility: [
            { required: true, message: '请选择是否具备采购面辅料的能力', trigger: 'change' },
          ],
          validProcessing: [
            { validator: validateProcessing },
          ],
          validSpecialProcess: [
            { validator: validateSpecialProcess },
          ],
          validQuality: [
            { validator: validateQuality }
          ],
          staffsNumber: [
            { required: true, message: '请输入员工人数', trigger: 'blur' },
          ],
          company: [
            { required: true, message: '请输入公司或机构名称', trigger: 'blur' },
          ],
          priceDuring: [
            {validator: validatePriceDuring}
          ],
          cateForLive: [
            { type: 'array', required: true, message: '请选择直播类目', trigger: 'change' },
          ]
        }
      };
    },
    computed: {
      ...mapGetters(['phone', 'userId'])
    },
    created() {
      this.getCategoryData()
    },
    methods: {
      // 获取数据
      getCategoryData() {
        request({
          url: api.getDatasource, 
					data: {
						types: '1,10101,11101,11102,11103'
          }
        }).then(res => {
          // console.log('api.getDatasource:res', res)
          if (res.errorCode == 200) {
            this.channel = res.data.channel
            this.clothesData = res.data.product.list.map((a, i) => {
              return {
                dataName: a.dataName,
                checked: false,
                list: a.list.map((b, j) => {
                  return {
                    name: b,
                    checked: false
                  }
                })
              }
            })
            this.clothesData2 = res.data.product.list.map((a, i) => {
              return {
                dataName: a.dataName,
                checked: false,
                list: a.list.map((b, j) => {
                  return {
                    name: b,
                    checked: false
                  }
                })
              }
            })

            this.processing = res.data.handleNeedProcessingLink
            this.specialProcess = res.data.handleSpecialProcess
            this.quality = res.data.mainQuantityStr
          } else {
            this.$message.error(res.errorMsg || '网络错误')
          }
        }).catch(err => {
          console.log('api.getDatasource:err', err)
        })
      },

      // 选择渠道
      selectChannel(e, item) {
        // console.log('selectChannel', e, item)
        e ? item.isSelect = '1' : item.isSelect = '0'
        // console.log(this.channel)
        this.$refs['regForm'].validateField('validChannel')
      },
      // 删除主营品类
      closeClothesTag(ele) {
        // console.log('closeClothesTag', ele);
        ele.checked =  false
        if (this.identityType == 1) {
          this.checkClothesData('clothesData', 'validClothesData')
        }
        if (this.identityType == 2) {
          this.checkClothesData('clothesData2', 'validClothesData2')
        }
      },
      // 选择主营品类
      changeClothesTag() {
        if (this.identityType == 1) {
          this.checkClothesData('clothesData', 'validClothesData')
        }
        if (this.identityType == 2) {
          this.checkClothesData('clothesData2', 'validClothesData2')
        }
      },
      // 主营品类 - 数据调整、校验
      checkClothesData(dataName, validName) {
        this[dataName].forEach(item => {
          item.checked = item.list.some(ele => ele.checked)
        })
        this.$refs['regForm'].validateField(validName)
      },

      // 选择加工环节
      selectProcessing(e, item) {
        // console.log('selectProcessing', e, item)
        e ? item.isSelect = '1' : item.isSelect = '0'
        // console.log(this.processing)
        this.$refs['regForm'].validateField('validProcessing')
      },

      // 选择特殊工艺
      selectSpecialProcess(e, item) {
        // console.log('selectSpecialProcess', e, item)
        e ? item.isSelect = '1' : item.isSelect = '0'
        // console.log(this.specialProcess)
        this.$refs['regForm'].validateField('validSpecialProcess')
      },

      // 选择品质产出
      selectQuality(e, item) {
        // console.log('selectQuality', e, item)
        this.quality.list.forEach(item => {
          item.dataName == e ? item.isSelect = '1' : item.isSelect = '0'
        })
        // console.log(this.quality, this.qualitySelect)
        this.$refs['regForm'].validateField('validQuality')
      },

      

      submitForm() {
        // console.log(this.regForm)
        this.$refs['regForm'].validate((valid) => {
          if (valid) {
            let identityText = {
              1: '品牌商',
              2: '生产商',
              9: '直播相关'
            }
            this.$confirm('您的身份是“' + identityText[this.identityType] + '”，确认后无法修改身份', '确认注册', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.submitPassword()
            })
          }
        })
      },
      // 设置密码
      submitPassword() {
        request({
          url: api.requestRegistUser,
          loading: true,
          data: {
            phone: this.phone,
            passWd: this.regForm.password1,
            checkPassWd:  this.regForm.password2,
            userType: this.identityType,
            userId: this.userId
          }
        }).then(res => {
          // console.log('api.requestRegistUser', res)
          if (res.errorCode === 200) {
            this.submitRegData()
          } else {
            this.$message.error(res.errorMsg || '网络错误')
          }
        })
      },
      // 设置其他资料
      submitRegData() {
        let params = {}
        if (this.identityType == 1) {
          params = {
            userType: this.identityType,
            phone: this.phone,
            userId: this.userId,
            regStr: JSON.stringify({
              product: this.clothesData,
              channel: this.channel
            })
          }
        }
        if (this.identityType == 2) {
          let processing = {
            ...this.processing,
            other: this.processingOther ? this.processingOtherText : ''
          }
          let specialProcess = {
            ...this.specialProcess,
            other: this.specialProcessOther ? this.specialProcessOtherText : ''
          }
          params = {
            userType: this.identityType,
            phone: this.phone,
            userId: this.userId,
            regStr: JSON.stringify({
              product: this.clothesData2,
            }),
            staffDevice: JSON.stringify({
              handleNeedProcessingLink: processing,
              handleSpecialProcess: specialProcess,
              mainQuantityStr: this.quality,
              canBuyFabricAbility: this.regForm.canBuyFabricAbility == '具备',
              staffsNumber: this.regForm.staffsNumber
            })
          }
        }
        if (this.identityType == 9) {
          params = {
            categoryForLive: this.regForm.cateForLive.join(','),
            companyOrInstitution: this.regForm.company,
            phone: this.phone,
            unitPrice: `${this.regForm.priceStart}-${this.regForm.priceEnd}`,
            userId: this.userId,
            userType: this.identityType,
          }
        }
        request({
          url: api.regData,
          loading: true,
          data: params
        }).then(res => {
          // console.log('api.regData', res)
          if (res.errorCode === 200) {
            this.$store.dispatch('setLoginInfo', {
              userType: this.identityType
            })
            this.$store.dispatch('getUserInfo')
            this.$message.success('恭喜您，注册成功!')
            this.$router.push('/')
          } else {
            this.$message.error(res.errorMsg || '网络错误')
          }
        })
      }

    }
}
</script>

<style lang="scss" scoped>
.register-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .register-header {
        height: 64px;
        background: #FFFFFF;
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        .logo {
            width: 166px;
            height: 28px;
            display: block;
            margin: 18px 0 0 24px;
        }
    }
    .register-main {
        flex: 1 1 auto;
        width: 884px;
        margin:  0 auto
    }
    .register-main-title {
        height: 76px;
        font-size: 24px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 76px;
    }
    .register-main-box {
        padding: 40px 100px;
        background: #FFFFFF;
        border-radius: 4px;

    }
    .identity-select {
        display: flex;
    }
    .identity-box {
        width: 218px;
        height: 80px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        margin-right: 16px;
        position: relative;
        &.act {
            border-color: #3F33FF;
            &::after {
                content: ' ';
                position: absolute;
                right: 12px;
                top: 12px;
                width: 22px;
                height: 22px;
                background: url(../../assets/icons/icon_tick.png) no-repeat center/100% 100%;
            }
        }
        .avatar {
            margin-left: 16px;
            width: 48px;
            height: 48px;
            background-size: cover;
            background-repeat: no-repeat;
            &.avatar_1 {
                background-image: url(../../assets/images/avatar_sample_1.png);
            }
            &.avatar_2 {
                background-image: url(../../assets/images/avatar_sample_2.png);
            }
            &.avatar_3 {
                background-image: url(../../assets/images/avatar_sample_3.png);
            }
        }
        strong {
            margin-left: 6px;
            font-size: 14px;
            color: #333;
        }
    }
    .cate-pop {
        .cate-line {
            margin-bottom: 16px;
        }
    }
    .cate-line {
        display: flex;
    }
    .cate-lab {
        font-weight: normal;
        width: 54px;
    }
    .cate-select {
      width: 600px;
      .el-tag {margin-right: 16px;}
      &.w {width: 800px;}
      .el-checkbox {width: 16%;}
    }
    .write-other {
      width: 200px;
      margin-left: 10px;
    }
    .divider {
      margin: 34px 0 24px;
      height: 1px;
      background-color: #DCDFE6;
    }
    
}
</style>